import React from 'react';
import autoBind from 'react-autobind';
import Paper from 'material-ui/Paper';
import MapIcon from 'material-ui/svg-icons/maps/map';
import MyLocation from 'material-ui/svg-icons/maps/my-location';
import TrainingIcon from 'material-ui/svg-icons/social/school';
import IconButton from 'material-ui/IconButton';
import { Link } from 'react-router-dom';
import EditLocationIcon from 'material-ui/svg-icons/maps/edit-location';
import TrainingModal from '../../../TrainingModal';
import colors from '../../../../themes/colors';
import { appContainer } from '../../../../contexts/app';

import './style.scss';

const LinkIcon = ({ to, icon, tooltip, isActive }) => (
  <Link className="icon" to={to}>
    <IconButton
      iconStyle={{ color: isActive ? colors.blue : '' }}
      tooltip={tooltip}
      tooltipPosition="bottom-right"
    >
      {icon}
    </IconButton>
  </Link>
);

const SidebarIcon = ({ matchFacilityId, match }) => {
  return (
    <Paper id="SidebarIcon">
      <LinkIcon
        isActive={match.url.startsWith('/facilities')}
        to={`/facilities/${matchFacilityId}`}
        icon={<EditLocationIcon />}
        tooltip="Edit Facility"
      />
      <LinkIcon
        isActive={match.url.startsWith('/marker-types')}
        to={`/marker-types?facilityId=${matchFacilityId}`}
        icon={<MyLocation />}
        tooltip="Edit Marker Types"
      />
      <LinkIcon
        isActive={match.url.startsWith('/map')}
        to={`/map/${matchFacilityId}`}
        icon={<MapIcon />}
        tooltip="View Map"
      />
      <TrainingTutorials />
    </Paper>
  );
};

class TrainingTutorials extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false
    };
    autoBind(this);
  }

  toggleModal() {
    const modalState = appContainer.state.get('trainingModalOpen');
    appContainer.set('trainingModalOpen', !modalState);
  }

  render() {
    return (
      <div id="trainingModal">
        <IconButton
          tooltip="Open Tutorials"
          tooltipPosition="bottom-right"
          onClick={this.toggleModal}
        >
          <TrainingIcon />
        </IconButton>
        <TrainingModal onRequestClose={this.toggleModal} />
      </div>
    );
  }
}

export default SidebarIcon;



// WEBPACK FOOTER //
// ./src/components/Sidebar/components/SidebarIcon/index.jsx